module.exports = __webpack_public_path__ + "static/avis-1-84f0e9ef633032f420d425da7daeaf86.jpg";